import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AddInsurer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();  const [formData, setFormData] = useState({
    name: '',
    company: '',
    contact_email: '',
    contact_phone: '',
    reputation_score: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error(t("insurer.alert.mustBeLoggedIn"));

      const { error } = await supabase.from('preferred_insurers').insert([
        {
          client_id: session.user.id,
          ...formData,
          reputation_score: parseFloat(formData.reputation_score),
        }
      ]);

      if (error) throw error;

      alert(t("insurer.alert.success"));
      navigate('/insurance');
    } catch (error) {
      alert(t("insurer.alert.error", { error: error.message }));
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-xl font-bold mb-4">{t("insurer.add.title")}</h1>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
        <input
          type="text"
          name="name"
          placeholder={t("insurer.form.name.placeholder")}
          value={formData.name}
          onChange={handleChange}
          required
          className="border p-2 rounded"
        />
        <input
          type="text"
          name="company"
          placeholder={t("insurer.form.company.placeholder")}
          value={formData.company}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <input
          type="email"
          name="contact_email"
          placeholder={t("insurer.form.email.placeholder")}
          value={formData.contact_email}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <input
          type="tel"
          name="contact_phone"
          placeholder={t("insurer.form.phone.placeholder")}
          value={formData.contact_phone}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <input
          type="number"
          step="0.1"
          name="reputation_score"
          placeholder={t("insurer.form.reputation.placeholder")}
          value={formData.reputation_score}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white py-2 rounded">
          {t("insurer.button.submit")}
        </button>
      </form>
    </div>
  );
};

export default AddInsurer;
